/**
 * Marketing-page scroll-reveal.
 * Adds `.in` to `.reveal` elements when they enter the viewport.
 * Honours prefers-reduced-motion: reveals everything immediately.
 *
 * Sticky-nav `.scrolled` toggle and FAQ accordion are handled
 * inline via Alpine on the marketing nav component.
 */
document.addEventListener('DOMContentLoaded', () => {
    const els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || !('IntersectionObserver' in window)) {
        els.forEach((el) => el.classList.add('in'));
        return;
    }

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in');
                    io.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    els.forEach((el) => io.observe(el));
});
